import VueLoader from '../../default/vue-loader'

import H4HBreadcrumb from '../add_to_cart_forms/h4h_hotels/h4h_breadcrumb'
import CheckoutBasic from './checkout_basic'
import CheckoutJqueryCarousel from './checkout_jquery_carousel'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(H4HBreadcrumb, document.getElementById('h4h-breadcrumb'))
})

export default {
  loadWithBasicAddOn() {
    return VueLoader.loadVueComponent(CheckoutBasic, document.getElementById('checkoutVue'))
  },

  loadWithJqueryAddOn() {
    return CheckoutJqueryCarousel.loadWithAddOnAndCarousel(this.loadWithBasicAddOn())
  }
}
